
<div id="menu-promo-container">
  <div id="menu-promo" class="titre d-flex">
    <button
      id="menu-promo-en-cours"
      :class="isArchive ? 'inactive' : 'active'"
      @click="showPromoArchive(false)"
    >
      {{ $t('messageComponent.promoEnCours') }}
    </button>
    <button
      id="menu-promo-archives"
      :class="isArchive ? 'active' : 'inactive'"
      @click="showPromoArchive(true)"
    >
      {{ $t('messageComponent.promoTerminees') }}
    </button>
  </div>
</div>
